var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 15,
    viewBox: "0 0 22 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.001 0.796875C6.73446 0.796875 3.52649 3.259 0.933097 6.45302C0.438967 7.06162 0.438967 7.93212 0.933097 8.54072C3.52649 11.7347 6.73446 14.1968 11.001 14.1968C15.2676 14.1968 18.4756 11.7347 21.069 8.54072C21.5631 7.93212 21.5631 7.06162 21.069 6.45302C18.4756 3.259 15.2676 0.796875 11.001 0.796875ZM9.20108 7.49683C9.20108 6.50273 10.007 5.69683 11.0011 5.69683C11.9952 5.69683 12.8011 6.50273 12.8011 7.49683C12.8011 8.49093 11.9952 9.29683 11.0011 9.29683C10.007 9.29683 9.20108 8.49093 9.20108 7.49683ZM11.0011 4.29683C9.23378 4.29683 7.8011 5.72953 7.8011 7.49683C7.8011 9.26413 9.23378 10.6968 11.0011 10.6968C12.7684 10.6968 14.2011 9.26413 14.2011 7.49683C14.2011 5.72953 12.7684 4.29683 11.0011 4.29683Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.9cbb8762c29728c8d795e1f672ff3780.svg";
export { ForwardRef as ReactComponent };